import pick from "lodash/pick";

import SinglePage from "@/components/SinglePage/SinglePage";

import { getPostBySlug } from "@/utils/postsApi";

export async function getStaticProps({ locale }) {
  const post = await getPostBySlug(
    "terms",
    ["title", "date", "content"],
    locale,
  );

  return {
    props: {
      messages: pick((await import(`locale/${locale}.json`)).default, [
        "common",
      ]),
      post,
    },
  };
}

export default SinglePage;
